<template lang="pug">
  div
    v-sheet.d-flex.align-center.blue100.round-xl.px-2.py-1(elevation="3")
      v-icon(size="32" color="neutral700") $yzi-layout-alt-duotone-04
      div.ml-3.mr-6
        div.text-xs.neutral700--text.font-semibold New & Improved Registration Page
        div.text-xs.neutral700--text Streamlined for speed and clarity.
      y-button(label="Learn more" size="xs" button-class="px-3" height="24" @click="showDialog = true; showSnackbar = false")

    // dialog
    y-dialog(v-model="showDialog" scrollable persistent max-width="1200" content-class="round-2xl")
      v-card(color="#ebebeb")
        v-card-title.pt-4.px-4.pb-0
          v-row(no-gutters align="center")
            v-col(cols="12" align="right")
              v-btn(icon @click="showDialog = false" small color="primary")
                v-icon(size="24") mdi-close
        v-card-text.px-6.pb-3
          div.text-3xl.font-semibold.text-center.neutral700--text Upgraded Registration page
          div.text-lg.text-center.neutral700--text.mt-2 Redesigned to meet your needs
          div.d-flex.justify-center.mt-4
            video(:src="require('@/assets/Video_switch_to_registration.mp4')" autoplay muted loop playsinline, :style="`height: ${videoHeight};`")
        v-divider
        v-card-actions.pb-4.pt-3.px-6
          v-spacer
          y-button(label="Switch to new version" color="neutral700" size="md" height="44" dark :loading="isLoading" @click="switchRegistration")
</template>

<script>
import {mapState, mapActions} from "vuex";

export default {
  data() {
    return {
      showSnackbar: true,
      showDialog: false,
      isLoading: false,
    }
  },
  computed: {
    ...mapState('user', ['member']),
    videoHeight() {
      let dialogHeight = window.innerHeight * 0.9
      let videoHeight = dialogHeight - 48 - 72 - 105
      return videoHeight + 'px'
    },
  },
  methods: {
    ...mapActions(['showMessage']),
    switchRegistration() {
      this.isLoading = true
      let params = {
        extra_data: {
          ...this.member.extra_data,
          new_registration: true
        }
      }
      this.$axios.patch(`/members/${this.member.id}/`, params)
          .then(resp => {
            this.$store.commit('user/setMember', resp.data)
            this.showDialog = false
            this.$emit('upgraded')
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
          .finally(() => {
            this.isLoading = false
          })
    },
  },
}
</script>

<style scoped>

</style>